import React from "react";

// Presentation only: callers supply the same filtered totals used by their lists.
export const FinanceSummaryCards = ({ items, testId, compactFirst = false, loading = false }) => (
  <div
    className={`management-metrics management-metrics-${items.length}${compactFirst ? " management-metrics-compact-count" : ""}`}
    data-testid={testId}
    aria-busy={loading}
  >
    {items.map(({ key, label, value, icon: Icon, tone = "neutral", valueTestId }) => (
      <div className={`management-metric management-metric-${tone}`} key={key} data-testid={`${testId}-${key}`}>
        <div className="management-metric-caption">
          <span data-testid={`${testId}-${key}-label`}>{label}</span>
          {Icon && <span className="management-metric-icon" aria-hidden="true"><Icon className="h-4 w-4" /></span>}
        </div>
        <div className="management-metric-value mono-num" data-testid={valueTestId || `${testId}-${key}-value`}>
          {loading ? "—" : value}
        </div>
      </div>
    ))}
  </div>
);